import { render, staticRenderFns } from "./setWord.vue?vue&type=template&id=4fcf17c8&scoped=true"
import script from "./setWord.vue?vue&type=script&lang=js"
export * from "./setWord.vue?vue&type=script&lang=js"
import style0 from "./setWord.vue?vue&type=style&index=0&id=4fcf17c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcf17c8",
  null
  
)

export default component.exports